import React from "react";
import { Box, IconButton } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { removeIcon } from "@common/icons";
import { removeItemClass, useDotLegalRemovableItemsStyles } from "./DotLegalRemovableItems.styles";

export interface IDotLegalRemovableItem {
    key: string;
    content: React.ReactNode;
    removeTooltip: string;
    /** Left out when the item cannot be removed, which renders it without a remove icon at all. */
    onRemove?: () => void;
    removeDisabled?: boolean;
}

export interface IDotLegalRemovableItems {
    items: Array<IDotLegalRemovableItem>;
}

function DotLegalRemovableItems(props: IDotLegalRemovableItems) {
    const styles = useDotLegalRemovableItemsStyles();

    if (props.items.length === 0) {
        return null;
    }

    return (
        <Box sx={styles.container}>
            {props.items.map((item) => (
                <Box key={item.key} sx={styles.item}>
                    {item.onRemove && (
                        <DotLegalTooltip text={item.removeTooltip}>
                            <Box component="span" sx={styles.removeItemContainer}>
                                <IconButton className={removeItemClass} sx={styles.removeItem} disabled={item.removeDisabled} onClick={item.onRemove}>
                                    {removeIcon}
                                </IconButton>
                            </Box>
                        </DotLegalTooltip>
                    )}
                    {item.content}
                </Box>
            ))}
        </Box>
    );
}

export default DotLegalRemovableItems;
